import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { Modal, Col, Form, Button } from 'react-bootstrap';
import { FormValidator } from '../../helpers/form-validator';
import { Validator } from '../widgets';
import { getOrganizationList, saveOrganization, getFarmOrganization } from '../../actions/organization';
import { getUserId } from "../../helpers/session";


const getRules = () => {
    const isSelect = (value) => { return (value === null) || (value === ""); }
    return ([
        {
            field: 'organizationName',
            method: 'isEmpty',
            validWhen: false,
            message: 'Organization Name is required.'
        },
        {
            field: 'organizationCategoryId',
            method: isSelect,
            validWhen: false,
            message: 'Organization Category is required.'
        }
    ]);

}

const OrganizationAddEditForm = props => {
    const { farm_uuid, onHide, isEdit, organizationName, organizationUuid, organizationCategoryId } = props;

    const validator = new FormValidator(getRules());

    const organizationDetail = useSelector(state => state.organization);
    const organizationCategory = useSelector(state => state.organization.organizationCategory);
    const organizationCat = organizationCategory && organizationCategory.length > 0 ?
        organizationCategory.map((e) => ({ value: e.organization_category_id, label: e.organization_category_name })) : [];


    const [submitted, setSubmitted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [state, setState] = useState({
        validation: validator.valid(),
        organizationName: organizationName,
        organizationUuid: isEdit ? organizationUuid : null,
        theme_id: isEdit ? (organizationDetail.themeId ? organizationDetail.themeId : null)
            : 1,
        organizationCategoryId: organizationCategoryId ? organizationCategoryId : 1
    });

    const saveOrganization = () => {
        const s = state;
        const validation = validator.validate(s);

        setState({ ...state, validation });
        setSubmitted(true);

        if (validation.isValid) {
            const params = {
                organization_name: s.organizationName,
                organization_uuid: s.organizationUuid,
                created_by: getUserId(),
                theme_id: s.theme_id ? s.theme_id : 1,
                organization_category_id: s.organizationCategoryId
            };

            const cb = (isSuccess) => {
                setIsSaving(false);
                if (isSuccess) {
                    props.actions.getOrganizationList();
                    props.actions.getFarmOrganization(farm_uuid);
                    onHide();
                }
            }

            setIsSaving(true);
            props.actions.saveOrganization(params, false, cb);
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    };

    const handleSelect = (options, id) => {
        if (options) setState({ ...state, [id]: options.value });
        else setState({ ...state, [id]: null });
    }

    const s = state;
    const v = submitted ? validator.validate(state) : state.validation;

    return <Modal show={true} onHide={onHide} backdrop="static" className="farm-modal-form">
        <Modal.Header closeButton>
            <Modal.Title>{`${isEdit ? "Edit Organization" : "Add Organization"}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form autoComplete='off'>
                <Form.Group>
                    <Validator validation={v.organizationName}>
                        <Form.Label htmlFor="txtFarmName">Organization Name<Validator.Mand /></Form.Label>
                        <Form.Control type="text"
                            id="txtOrganizationName"
                            name="organizationName"
                            placeholder="Enter the organization name"
                            maxLength='50'
                            value={s.organizationName}
                            onChange={handleChange}
                            autoComplete="off" />
                        <Validator.Text />
                    </Validator>
                    <Validator validation={v.organizationCategoryId}>
                        <Form.Label htmlFor="organizationCategory">Organization Category<Validator.Mand /></Form.Label>
                        <Form.Select
                            id="organizationCategoryId"
                            placeholder="Select Organization Category"
                            name="organizationCategoryId"
                            onChange={(e) => handleSelect(e, "organizationCategoryId")}
                            value={s.organizationCategoryId}
                            options={organizationCat}
                        />
                        <Validator.Text />
                    </Validator>

                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Col className="p-0">
                <Button variant="primary" size="sm" className="float-right mx-1" onClick={saveOrganization}>
                    <i className="fa fa-floppy-o"></i>{isSaving ? " Saving..." : " Save"}
                </Button>
                <Button variant="danger" size="sm" className="float-right mx-2" onClick={onHide}>
                    <i className="fa fa-times-circle"></i> Cancel
                </Button>
            </Col>
        </Modal.Footer>
    </Modal>;
};
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getOrganizationList, saveOrganization, getFarmOrganization }, dispatch)
});

const mapStateToProps = (state) => ({
    organizationList: state.organization.organizationList,
    farm_uuid: state.farm.currentFarm.farm_uuid
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationAddEditForm);